import ArrowDownIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpIcon from '@mui/icons-material/ArrowUpward';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { IconButton, List, ListItem, ListItemSecondaryAction, ListItemText } from '@mui/material';
import React, { useState } from 'react';
import { TeamHeroMenuComponentInterface, TeamHeroMenuItem } from '../../../../../../interfaces/pagebuilder';
import { useSelector } from '../../../../../../reduxToolkit/typedRedux';
import ItemForm from './ItemForm';

interface ItemsList {
  component: TeamHeroMenuComponentInterface;
  onChange: (component: TeamHeroMenuComponentInterface) => void;
  withHasModalOption?: boolean;
}

const ItemsList = ({ component, onChange, withHasModalOption = true }: ItemsList) => {
  const [editingEntry, setEditingEntry] = useState<number | null>(null);
  const event = useSelector((state) => state.common.event);

  function deleteEntry(index: number) {
    const newComp = { ...component };

    newComp.items = newComp.items?.filter((_, i) => i !== index).map((item) => (item.sortIndex > index ? { ...item, sortIndex: item.sortIndex - 1 } : item));
    onChange(newComp);
  }

  function changePosition(index: number, newIndex: number) {
    const newComp: TeamHeroMenuComponentInterface = {
      ...component,
      items: component.items?.map((item) => {
        if (item.sortIndex !== index && item.sortIndex !== newIndex) return item;
        if (item.sortIndex === index) return { ...item, sortIndex: newIndex };
        return { ...item, sortIndex: index };
      }),
    };
    onChange(newComp);
  }

  async function editEntry(props: TeamHeroMenuItem) {
    const newComp = {
      ...component,
      items: component.items?.map((item) => (item.sortIndex === props.sortIndex ? props : item)),
    };

    setEditingEntry(null);
    onChange(newComp);
  }

  return (
    <>
      <List className="items-list" dense>
        {component?.items
          ?.slice()
          .sort((a, b) => a.sortIndex - b.sortIndex)
          .map((item, index) => (
            <ListItem key={item.sortIndex}>
              <ListItemText primary={item.text} />
              <ListItemSecondaryAction>
                {index !== 0 && (
                  <IconButton onClick={() => changePosition(index, index - 1)} edge="end" aria-label="move up" size="large">
                    <ArrowUpIcon />
                  </IconButton>
                )}

                {component.items?.length && index !== component.items.length - 1 && (
                  <IconButton onClick={() => changePosition(index, index + 1)} edge="end" aria-label="move down" size="large">
                    <ArrowDownIcon />
                  </IconButton>
                )}

                <IconButton onClick={() => setEditingEntry(index)} edge="end" aria-label="edit" size="large">
                  <EditIcon />
                </IconButton>

                <IconButton onClick={() => deleteEntry(index)} edge="end" aria-label="delete" size="large">
                  <DeleteIcon />
                </IconButton>
              </ListItemSecondaryAction>
            </ListItem>
          ))}
      </List>
      {editingEntry !== null && component.items && component?.items[editingEntry] && (
        <ItemForm
          isModal
          isModalOpen={!!editEntry}
          defaultValues={component?.items?.[editingEntry]}
          onItemCreated={editEntry}
          onCloseModal={() => setEditingEntry(null)}
          withHasModalOption={withHasModalOption}
        />
      )}
    </>
  );
};

export default ItemsList;
